<template>
	<information-card
		title="Escoger Empleados"
		sub-title="Instrucciones"
	>
		<div slot="content">
			<p class="textjustify">Selecciona los empleados que vas a evaluar por área.
			</p>
			<br>
			<div class="content-rule">
				<br>
				<p>Paso 1:	<span class="text-color">	Seleccionar área.</span></p>
                <p>Paso 2:	<span class="text-color">	Escoge los empleados a evaluar.</span></p>
                <p>Paso 3: 	<span class="text-color">	Siguiente para asignar sus evaluadores.</span></p>
			</div>
		</div>
	</information-card>
</template>

<script>
import InformationCard from '@/modules/shared/components/content/InformationCard';

export default {
	name: 'process-model-description-employees',
	components: {
		InformationCard,
	},
};

</script>

<style lang="scss" scoped>
.textjustify {
	text-align: center;
	font-size: 12px;
}
.content-rule {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: center;
	border: 1px solid map-get($colors, gray-slider);
	background-color: #F9F9F9;
    padding: 0 20px;
	border-radius: 4px;
	font-size: 10px;
}
.text-color {
	color: #f09c2e;
}
.table-info {
	border: #f09c2e 1px solid;
	display: flex;
	width: 100%;
	flex-direction: column;
	align-items: center;
	justify-content: center;
}
.row-table-info {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	
}
.btn-model {
	background-color: #F9F9F9;
	width: 50px;
	height: 25px;
	border-radius: 8px;

}
</style>


// WEBPACK FOOTER //
// src/modules/evaluation-360/components/process/process-model-description-employees.vue